export default __webpack_public_path__ + "static/media/lenovoComputer.9098b8b6.png";